<template>
  <div class="p-5 full-h">
    <el-row :gutter="20" class="mb-10">
      <el-col :span="6">
        <div class="pr-5">
          <el-card class="current-month mb-5 text-center">
            <div>Current Month</div>
            <div class="value">{{ stat ? stat.current_month : 0 }}</div>
          </el-card>
          <el-card class="total text-center">
            <div>Total</div>
            <div class="value">{{ stat ? stat.total : 0 }}</div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="18" class="chart">
        <div class="pl-5">
          <StatChart :monthlyStats="monthlyStats" />
        </div>
      </el-col>
    </el-row>
    <el-row class="mb-3">
      <el-col :span="12">
        <el-date-picker
          :editable="false"
          :clearable="false"
          v-model="selectedMonth"
          type="month"
          format="yyyy/MM"
          @change="getTemplateStatList">
        </el-date-picker>
      </el-col>
      <el-col :span="12" class="selected-month-count">
        Total: <span>{{ total }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          border
          :data="templateStats"
          style="width: 100%"
          class="mb-3"
        >
          <el-table-column label="Request Date" align="center" width="200">
            <template slot-scope="scope">
              {{ scope.row.created ? $moment(scope.row.created).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </template>
          </el-table-column>
          <el-table-column
            property="name"
            label="OCR Name">
          </el-table-column>
          <el-table-column
            property="template_name"
            label="Template Name">
          </el-table-column>
          <el-table-column
            property="n_files"
            label="Number Of Files"
            align="right"
            width="150"
          >
          </el-table-column>
          <el-table-column
            property="n_boxes"
            label="Number Of Boxes"
            align="right"
            width="150"
          >
          </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size="limit"
            :total="total"
            :current-page.sync="currentPage"
            @current-change="getTemplateStatList"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  import StatChart from '@/components/admin/organizations/StatChart';
  import { MONTHLY_TYPE } from "@/constants/organization";

  export default {
    name: 'OrganizationStat',
    components: { StatChart },
    data () {
      return {
        currentPage: 1,
        selectedMonth: new Date()
      }
    },
    computed: {
      ...mapState({
        stat: state => state.admin_stats.stat,
        monthlyStats: state => state.admin_stats.monthly_stats,
        templateStats: state => state.admin_stats.template_stats,
        total: state => state.admin_stats.total,
        limit: state => state.admin_stats.limit
      }),
    },
    methods: {
      ...mapActions('admin_stats', ['getStat', 'getMonthlyStats', 'getTemplateStats']),
      getTemplateStatList () {
        let selectedMonthMoment = this.$moment(this.selectedMonth);
        this.getTemplateStats({
          org_id: this.$route.params.id,
          page: this.currentPage,
          from_date: selectedMonthMoment.startOf('month').format('YYYY-MM-DD HH:mm:ss.0000'),
          to_date: selectedMonthMoment.endOf('month').format('YYYY-MM-DD HH:mm:ss.9999'),
        });
      }
    },
    created () {
      this.getStat({
        id: this.$route.params.id
      });

      this.getMonthlyStats({
        id: this.$route.params.id,
        type: MONTHLY_TYPE
      });

      this.getTemplateStatList();
    }
  }
</script>
<style scoped>
  .current-month .value {
    font-size: 30px;
    font-weight: bold;
    color: #409EFF;
  }

  .total .value {
    font-size: 30px;
    font-weight: bold;
    color: #E6A23C;
  }

  .selected-month-count {
    line-height: 40px;
    text-align: right;
  }
</style>
